import { Button, Modal } from "react-bootstrap";
import CancelIcon from "@material-ui/icons/Cancel";
import { Loyalty } from "@mui/icons-material";
import { useEffect, useState } from "react";
import config from "../../config";
import { useSelector } from "react-redux";
import { useCustomerData } from "../../provider/billingProviders/customerDataProvider";
import { GENERATEBILLACCESS } from "../../utils/constant";
import { useAccess } from "../../provider/AccessProvider";
import { Typography } from "antd";
import { useCurrency } from "../../provider/courtryProvider";

const LoyaltyModal = ({ open, onClose = () => {} }) => {
  const [loyaltyList, setLoyaltyList] = useState([]);
  const access = useAccess(GENERATEBILLACCESS);
  const shopDetails = useSelector((state) => state.shopDetails);
  const { productList } = useSelector((state) => state.products);
  const currencyFormatter = useCurrency();
  const { customerData, applyLoyaltyPoints, removeLoyaltyPoints } =
    useCustomerData();
  const fetchLoyaltyCoupon = async (shopId) => {
    if (shopId === "") return;
    await Promise.all([
      fetch(`${config.newApiGateway}/loyalty/loyalty`, {
        method: "POST",
        body: JSON.stringify({
          shopId: shopId,
          action: "fetchLoyaltyCoupon",
        }),
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
      }),
    ])
      .then(([res]) => Promise.all([res.json()]))
      .then(async ([data]) => {
        setLoyaltyList(data);
      })
      .catch((err) => {
        console.error(err);
      });
  };
  useEffect(() => {
    if (shopDetails.shopId) {
      fetchLoyaltyCoupon(shopDetails.shopId);
    }
  }, [shopDetails.shopId]);
  return (
    <Modal
      scrollable={true}
      show={open}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      onHide={() => {
        onClose();
      }}
      style={{ padding: 0, margin: 0 }}
    >
      <Modal.Header>
        <div>
          <button
            className="closebutton"
            onClick={() => {
              onClose();
            }}
          >
            <CancelIcon />
          </button>
          <div
            className="couponheading"
            style={{ marginTop: 20, marginBottom: 5 }}
          >
            <div>
              <Loyalty style={{ fontSize: 20 }} />
            </div>
            <h3>Available Loyalty Coupons</h3>
          </div>
        </div>
      </Modal.Header>
      <Modal.Body
        style={{
          background: "#f5f9fc",
          maxHeight: "calc(100vh - 210px)",
          overflowY: "auto",
        }}
      >
        {loyaltyList.length > 0 ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              flexWrap: "wrap",
              margin: "20px",
            }}
          >
            {loyaltyList.map((data) => {
              let isProductExist = {};
              let isDisabled = false;
              if (data?.rewardType?.name === "product") {
                isProductExist = productList.find(
                  (product) => product.productId === data?.rewardType?.value
                );
                isDisabled = !isProductExist;
              }
              console.log("isProductExist", isProductExist, data.couponDetails);
              return (
                <div
                  style={{
                    width: "100%",
                    height: "auto",
                    border: "1px solid rgb(214, 214, 214)",
                    borderRadius: "5px",
                    boxShadow: "3px 3px 5px 1px rgb(231, 231, 231)",
                    marginBottom: "20px",
                    marginRight: "10px",
                    marginLeft: "20px",
                    position: "relative",
                  }}
                  key={data.couponId}
                >
                  <div
                    className="inCardStyle"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <div
                      style={{
                        width: "30%",
                        textAlign: "center",
                        fontSize: "14px",
                        backgroundColor: "#0dcaf0",
                        paddingTop: "5px",
                        color: "white",
                        borderRadius: "5px 0px 0px 5px",
                        margin: "5px",
                      }}
                    >
                      USE {data.minLoyaltyPointsReq} LOYALTY POINTS
                    </div>
                    <div
                      style={{
                        height: "85px",
                        border: "2px dotted black",
                      }}
                    ></div>
                    <div style={{ width: "70%", margin: "5px" }}>
                      <div style={{ width: "70%" }}>
                        <Typography.Text>
                          Name: {data.couponDetails}
                        </Typography.Text>
                        <br />
                        <Typography.Text
                          style={{
                            textTransform: "capitalize",
                          }}
                        >
                          Reward Type: {data.rewardType?.name}
                        </Typography.Text>
                        <br />
                        <Typography.Text
                          style={{
                            textTransform: "capitalize",
                          }}
                        >
                          Reward Value:{" "}
                          {data.rewardType?.name === "product"
                            ? isProductExist?.productName || (
                                <span
                                  style={{
                                    color: "red",
                                    textTransform: "none",
                                  }}
                                >
                                  Product is deleted
                                </span>
                              )
                            : currencyFormatter(data.rewardType?.value)}
                        </Typography.Text>
                      </div>

                      {customerData.loyalty?.couponId === data.couponId ? (
                        <Button
                          disabled={
                            parseFloat(data.minLoyaltyPointsReq) >
                              parseFloat(customerData.loyaltyPoints || 0) ||
                            isDisabled
                          }
                          variant="outline-info"
                          size="sm"
                          style={
                            parseFloat(data.minLoyaltyPointsReq) >
                              parseFloat(customerData.loyaltyPoints || 0) ||
                            isDisabled
                              ? {
                                  cursor: "not-allowed",
                                  position: "absolute",
                                  top: "10px",
                                  right: "10px",
                                }
                              : {
                                  position: "absolute",
                                  top: "10px",
                                  right: "10px",
                                }
                          }
                          onClick={() => {
                            removeLoyaltyPoints(customerData.loyalty);
                            onClose();
                          }}
                        >
                          Remove
                        </Button>
                      ) : (
                        <Button
                          disabled={
                            parseFloat(data.minLoyaltyPointsReq) >
                              parseFloat(customerData.loyaltyPoints || 0) ||
                            isDisabled
                          }
                          variant="outline-info"
                          size="sm"
                          style={
                            parseFloat(data.minLoyaltyPointsReq) >
                              parseFloat(customerData.loyaltyPoints || 0) ||
                            isDisabled
                              ? {
                                  cursor: "not-allowed",
                                  position: "absolute",
                                  top: "10px",
                                  right: "10px",
                                }
                              : {
                                  position: "absolute",
                                  top: "10px",
                                  right: "10px",
                                }
                          }
                          onClick={() => {
                            if (!access.loyaltyRedeem(false)) {
                              alert(
                                "You do not have access to this feature. Please contact your administrator to request the appropriate access."
                              );
                              return;
                            }
                            applyLoyaltyPoints(data);
                            onClose();
                          }}
                        >
                          Redeem
                        </Button>
                      )}
                    </div>
                  </div>
                  <div></div>
                </div>
              );
            })}
          </div>
        ) : (
          <div
            className="cardContainer"
            style={{ textAlign: "center", marginTop: "20px", opacity: "0.5" }}
          >
            <p>No Coupons To Show</p>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default LoyaltyModal;
